import { message, Spin } from "antd";
import { isAxiosError } from "axios";
import { useSearchParams } from "react-router-dom";

import { useChangePassword } from "@hooks/useChangePassword";

import { LoginChangePassword } from "@components/molecules";
import { ArrowLeft } from "@phosphor-icons/react";

export const ChangePassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const { changePassword, isLoading: isChangingPassword } = useChangePassword();

  const handleChangePassword = (data: { password: string; confirmPassword: string }) => {
    if (!token) {
      message.error("Token de redefinição não encontrado");
      return;
    }

    changePassword.mutate(
      {
        token: token,
        newPassword: data.password,
      },
      {
        onSuccess: () => { },
        onError: (error) => {
          if (isAxiosError(error)) {
            // message.error(error.response?.data.message || 'Erro ao alterar senha');
          }
        },
      }
    );
  };

  return (
    <Spin spinning={isChangingPassword}>
      <div className="flex min-h-screen bg-[url(/background-login.jpg)] bg-cover bg-center">
        <div className="hidden flex-1 flex-col justify-center p-10 relative md:flex">
          <div className="absolute top-5 left-5">
            <a
              href="https://www.ruppertinc.com/"
              className="text-gray-400! hover:text-white! flex items-center gap-2 text-xs font-light"
            >
              <ArrowLeft />
              Back to website
            </a>
          </div>

          <div className="absolute top-20 left-10 w-20">
            <img src="./logo-small-icon.svg" alt="Ruppert" />
          </div>

          <h1 className="text-primary text-6xl font-extralight">Empowering your legacy with AI</h1>
        </div>
        <div className="flex flex-col justify-center p-8 bg-white shadow w-full md:max-w-md md:p-10">
          <h2 className="mb-10 flex justify-center md:justify-end">
            <img src="./logo-horizontal-dark.svg" alt="Ruppert" className="w-50 md:w-40" />
          </h2>
          <LoginChangePassword onFinish={handleChangePassword} />
        </div>
      </div>
    </Spin>
  );
};
